(function () {
  'use strict';

  var SESSION_STARTED = 'ssPlannerDemoOverlay.started';
  var SESSION_WELCOME = 'ssPlannerDemoOverlay.welcomeDismissed';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function parseConfig(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function focusable(node) {
    if (!node) return [];
    return qsa(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
      node
    ).filter(function (el) {
      return !el.hidden && el.offsetParent !== null;
    });
  }

  function PlannerDemoOverlay(root) {
    this.root = root;
    this.configEl = qs('[data-ss-demo-overlay-config]', root);
    this.config = parseConfig(this.configEl) || {};
    this.openers = qsa('[data-ss-demo-open]');
    this.backdrop = qs('[data-ss-demo-backdrop]', root);
    this.closeButtons = qsa('[data-ss-demo-close-btn]', root);
    this.welcome = qs('[data-ss-demo-welcome]', root);
    this.frameWrap = qs('[data-ss-demo-frame-wrap]', root);
    this.startBtn = qs('[data-ss-demo-start]', root);
    this.tourBtn = qs('[data-ss-demo-tour]', root);
    this.purchaseLinks = qsa('[data-ss-demo-purchase]', root);
    this.iframe = qs('[data-ss-demo-iframe]', root);
    this.loading = qs('[data-ss-demo-loading]', root);
    this.lastFocus = null;
    this.scrollY = 0;
    this.loaded = false;
    this.pendingTour = false;
    this.bind();
  }

  PlannerDemoOverlay.prototype.bind = function () {
    var self = this;
    this.openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.open(btn);
      });
    });
    this.closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { self.close(); });
    });
    if (this.backdrop) {
      this.backdrop.addEventListener('click', function () { self.close(); });
    }
    this.root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ss-demo-start]')) {
        e.preventDefault();
        self.startDemo(false);
        return;
      }
      if (e.target.closest('[data-ss-demo-tour]')) {
        e.preventDefault();
        self.startDemo(true);
        return;
      }
      if (e.target.closest('[data-ss-demo-compare]')) {
        e.preventDefault();
        self.toggleCompare();
      }
    });
    this.purchaseLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        try { sessionStorage.setItem('ssPlannerDemoOverlay.purchaseClick', String(Date.now())); } catch (e) {}
      });
    });
    this.root.addEventListener('keydown', function (e) {
      if (!self.root.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        self.close();
        return;
      }
      if (e.key === 'Tab') self.trapFocus(e);
    });
    window.addEventListener('message', function (e) {
      if (!self.root.classList.contains('is-open')) return;
      if (!e || !e.data || !e.data.type) return;
      if (e.data.type === 'ss-demo-ready' && self.pendingTour) {
        self.notifyIframeTour();
      }
      if (e.data.type === 'ss-demo-tour-started') {
        self.pendingTour = false;
      }
    });
  };

  PlannerDemoOverlay.prototype.open = function (trigger) {
    this.lastFocus = trigger || document.activeElement;
    this.scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('ss-planner-demo-overlay-open');
    document.body.style.top = '-' + this.scrollY + 'px';
    this.root.hidden = false;
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    var welcomeDismissed = false;
    try { welcomeDismissed = sessionStorage.getItem(SESSION_WELCOME) === '1'; } catch (e) {}
    var started = false;
    try { started = sessionStorage.getItem(SESSION_STARTED) === '1'; } catch (e) {}
    if (started && this.iframe && this.iframe.src) {
      var iframeSrc = this.iframe.getAttribute('src') || '';
      if (iframeSrc.indexOf('embed=1') === -1) {
        this.loaded = false;
        this.startDemo(false);
      } else {
        this.showFrame();
      }
    } else if (welcomeDismissed) {
      this.startDemo(false);
    } else {
      this.showWelcome();
    }
    var focusTarget = this.welcome && !this.welcome.hidden ? qs('button, a', this.welcome) : qs('[data-ss-demo-close-btn]', this.root);
    if (focusTarget) focusTarget.focus();
  };

  PlannerDemoOverlay.prototype.close = function () {
    this.root.classList.remove('is-open');
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ss-planner-demo-overlay-open');
    document.body.style.top = '';
    window.scrollTo(0, this.scrollY);
    var self = this;
    window.setTimeout(function () {
      if (!self.root.classList.contains('is-open')) self.root.hidden = true;
    }, 240);
    if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
      try { this.lastFocus.focus(); } catch (e) {}
    }
  };

  PlannerDemoOverlay.prototype.showWelcome = function () {
    if (this.welcome) {
      this.welcome.hidden = false;
      this.welcome.removeAttribute('aria-hidden');
    }
    if (this.frameWrap) {
      this.frameWrap.hidden = true;
      this.frameWrap.setAttribute('aria-hidden', 'true');
    }
    this.toggleCompare(false);
  };

  PlannerDemoOverlay.prototype.toggleCompare = function (show) {
    var panel = qs('[data-ss-demo-compare-panel]', this.root);
    if (!panel) return;
    var shouldShow = typeof show === 'boolean' ? show : panel.hidden;
    panel.hidden = !shouldShow;
    if (shouldShow) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  };

  PlannerDemoOverlay.prototype.showFrame = function () {
    if (this.welcome) {
      this.welcome.hidden = true;
      this.welcome.setAttribute('aria-hidden', 'true');
    }
    if (this.frameWrap) {
      this.frameWrap.hidden = false;
      this.frameWrap.removeAttribute('aria-hidden');
    }
  };

  PlannerDemoOverlay.prototype.buildIframeSrc = function (withTour) {
    var base = this.config.demoUrl || '';
    if (!base) return '';
    var join = base.indexOf('?') === -1 ? '?' : '&';
    var src = base + join + 'embed=1';
    if (withTour) src += '&tour=1';
    return src;
  };

  PlannerDemoOverlay.prototype.notifyIframeTour = function () {
    if (!this.pendingTour || !this.iframe || !this.iframe.contentWindow) return;
    try {
      this.iframe.contentWindow.postMessage({ type: 'ss-demo-restart-tour' }, '*');
    } catch (e) {}
  };

  PlannerDemoOverlay.prototype.startDemo = function (withTour) {
    this.pendingTour = !!withTour;
    var src = this.buildIframeSrc(withTour);
    if (!src) {
      this.pendingTour = false;
      if (this.loading) {
        this.loading.hidden = false;
        this.loading.textContent = 'Demo could not be loaded. Refresh the page and try again.';
      }
      return;
    }
    try { sessionStorage.setItem(SESSION_WELCOME, '1'); } catch (e) {}
    try { sessionStorage.setItem(SESSION_STARTED, '1'); } catch (e) {}
    this.showFrame();
    if (!this.iframe) return;

    var self = this;
    var currentSrc = this.iframe.getAttribute('src') || '';
    var needsLoad =
      !this.loaded ||
      !currentSrc ||
      currentSrc.indexOf('embed=1') === -1 ||
      (withTour && currentSrc.indexOf('tour=1') === -1);

    function onIframeLoad() {
      if (self.loading) self.loading.hidden = true;
      self.loaded = true;
      self.notifyIframeTour();
    }

    if (needsLoad) {
      if (this.loading) {
        this.loading.hidden = false;
        this.loading.textContent = withTour
          ? 'Loading interactive demo and starting tour…'
          : 'Loading interactive demo…';
      }
      this.iframe.addEventListener('load', function onLoad() {
        self.iframe.removeEventListener('load', onLoad);
        onIframeLoad();
      }, { once: true });
      this.iframe.src = src;
    } else {
      if (this.loading) this.loading.hidden = true;
      if (withTour) {
        this.notifyIframeTour();
      }
    }
    this.iframe.focus();
  };

  PlannerDemoOverlay.prototype.trapFocus = function (e) {
    var nodes = focusable(this.root);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  function init() {
    var root = qs('[data-ss-planner-demo-overlay]');
    if (!root) return;
    new PlannerDemoOverlay(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
